import { type WithdrawDetailsChilizInfo, type WithdrawDetailsFanTokensInfo } from './useWalletWithdrawDetails';

export const useWalletWithdrawCurrencyActions = ({
	chilizInfo,
	fanTokensInfo,
	openCHZOnHoldDrawer,
	openFanTokenSelector,
	openNotEnoughCHZDrawer,
	openNotEnoughFanTokensDrawer,
	openWarningCHZWithdrawDrawer
}: {
	chilizInfo: WithdrawDetailsChilizInfo;
	fanTokensInfo: WithdrawDetailsFanTokensInfo;
	openCHZOnHoldDrawer: () => void;
	openFanTokenSelector: () => void;
	openNotEnoughCHZDrawer: () => void;
	openNotEnoughFanTokensDrawer: () => void;
	openWarningCHZWithdrawDrawer: () => void;
}) => {
	const handleCHZCardClick = () => {
		if (chilizInfo.hasEnoughCHZAvailabletoWithdraw) {
			// Enough CHZ
			openWarningCHZWithdrawDrawer();
		} else if (chilizInfo.hasEnoughCHZtoWithdraw) {
			// Not enough balance + locked
			openCHZOnHoldDrawer();
		} else {
			// Not enough balance
			openNotEnoughCHZDrawer();
		}
	};
	const handleFanTokensCardClick = () => {
		if (fanTokensInfo.hasEnoughFantokensToWithdraw) {
			openFanTokenSelector();
		} else {
			openNotEnoughFanTokensDrawer();
		}
	};

	return {
		handleCHZCardClick,
		handleFanTokensCardClick
	};
};
